<template>
  <div>
    <b-media right-align>
      <b-media-body class="ml-2" align="left">
        <h4 class="mt-3 mb-3"> 오시는 길 </h4>
      </b-media-body>
    </b-media>
    <b-container fluid>
      <b-row>
        <b-col>
          <GmapMap
          :center="{lat:37.549478, lng:127.051103}"
          :zoom="15"
          map-type-id="roadmap"
          style="width: 360px; height: 270px"
        >
          <GmapMarker
            :key="m.id"
            v-for="m in markers"
            :position="m.position"
            :clickable="true"
            :draggable="true"
            @click="center=m.position"
          />
        </GmapMap>
        </b-col>
        <b-col>
          <b-media right-align>
            <b-media-body class="mt-3" align="left">
              <h4 class="mt-0 ml-0">서울 사무실</h4>
              <p>
                <a href="http://naver.me/FrCj3reh">서울시 성동구 성수일로 99 AK밸리 706호</a>
              </p>
              <p>
                2호선 뚝섬역 4번 출구
              </p>
              <p>
                2호선 성수역 1번 출구
              </p>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <GmapMap
            :center="{lat:36.742523, lng:127.991220}"
            :zoom="7"
            map-type-id="roadmap"
            style="width: 360px; height: 270px"
          >
            <GmapMarker
              :key="m.id"
              v-for="m in markers"
              :position="m.position"
              :clickable="true"
              :draggable="true"
              @click="center=m.position"
            />
          </GmapMap>
        </b-col>
        <b-col>
          <b-media right-align>
            <b-media-body class="mt-3 ml-0" align="left">
              <h4 class="mt-0 ml-0">연풍 공장</h4>
              <p>
                <a href="http://naver.me/5fS5F3Wi">충청북도 괴산군 연풍면 은티중리길 248</a>              </p>
              <p>
              </p>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: 'Contact',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      markers: [
        { id: 'company', position: { lat: 37.549478, lng: 127.051103 } },
        { id: 'factory', position: { lat: 36.742523, lng: 127.991220 } }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue